export const UNKNOWN_BRAND_NAME = "Stadium";

export const { snackmagic, swagmagic, superiordishes, stadium, teambuilds } = {
  snackmagic: {
    key: "snackmagic",
    title: "SnackMagic",
  },
  swagmagic: {
    key: "swagmagic",
    title: "SwagMagic",
  },
  superiordishes: {
    key: "superiordishes",
    title: "SuperiorDishes",
  },
  stadium: {
    key: "stadium",
    title: "Stadium",
  },
  teambuilds: {
    key: "teambuilds",
    title: "TeamBuilds",
  },
};
